import { ERR_CANNOT_GET_DATA_FROM_SERVER } from "../../constants"
import { createGenericAuthRequest, createPostRequest } from "../request/request-utils"

const BASE_URL = process.env.REACT_APP_ELEARN_URL || '/'
const BASE_PATH = "/bellringers"
const request = createGenericAuthRequest(BASE_URL)
const requestPost = createPostRequest(BASE_URL)

async function getAllUserBellringers() {
    return request(`${BASE_PATH}/user/bellringer`)
}

async function getUserBellringer(bellringerId: string) {
    return request(`${BASE_PATH}/user/bellringer/${bellringerId}`)
}

async function getBellringer(bellringerId: string) {
    return request(`${BASE_PATH}/bellringer/${bellringerId}`)
}

async function upsertUserBellringer(bellringerId: string, userSubmittedAnswer: string, bookmarked: boolean, studyTimeInSeconds: number) {
    let payload = {bellringerId, userSubmittedAnswer, bookmarked, studyTimeInSeconds}
    let data = JSON.stringify(payload)
    return requestPost(`${BASE_PATH}/user/bellringer`, data)
}

async function getBellringersWeeklyTestQuestionsWithUserAnswers(bellringersTestId: string) {
    return request(`${BASE_PATH}/user/bellringer/test/${bellringersTestId}`)
}

async function getStudentTestRestultsForTeacher() {
    return request(`${BASE_PATH}/teacher/student-test-results`)
}

async function getStudentTestRestultsWithMetaDataForTeacher() {
    return request(`${BASE_PATH}/teacher/student-test-results-with-metadata`)
}

async function getBellringersMetaDataForTeacher() {
    return request(`${BASE_PATH}/teacher/bellringers-metadata`)
}


export const BellringersRest = {
    getAllUserBellringers,
    getUserBellringer,
    getBellringer,
    upsertUserBellringer,
    getBellringersWeeklyTestQuestionsWithUserAnswers,
    getStudentTestRestultsForTeacher,
    getStudentTestRestultsWithMetaDataForTeacher,
    getBellringersMetaDataForTeacher,
}
